module.exports = __webpack_public_path__ + "Icon_Safer Behaviours@2x.png?58991dc546ec828494120f015bef4b98";